import React from 'react';
// import { Link } from 'react-router-dom';
// import error from '../../../assets/404.svg';
// import { PATH_INTRO, PATH_ROOT } from '../../paths';
// import {
//   ErrorContainer, ErrorSubText, ErrorText, ErrorWhiteButton,
// } from './styles';
// import { Title } from '../../design/Title';
// import { Content, Img, ImgHolder } from '../../design/StandartPage/styles';

export const Root = () => {
  return (
    <>root</>
  );
};

/*
    <ErrorContainer>
      <ImgHolder>
        <Img src={error}/>
      </ImgHolder>
      <Content>
        <Title>
          Web Active Liveness
        </Title>
        <ErrorText>
          <Link to={`${PATH_ROOT}${PATH_INTRO}`}>
            by Enface
          </Link>
          <ErrorSubText>
  Web Active Liveness check by enface.ai can be described as biometric verification as
  the
  protection of personal data.
  <br/>
  <br/>
  As the biometric component, the system uses facial recognition with liveness feature.
    Enface
  uses active and passive liveness for anti-spoofing protection.
  </ErrorSubText>
  <br/>
  <Title size={'18px'}>
  How to start using
  </Title>
  <ErrorSubText>
  <ul style={{ marginLeft: '-20px' }}>
  <li><span>Allow access to the camera</span></li>
  <li><span>Take off anything from your face</span></li>
  <li><span>Position yor face in the camera frame</span></li>
  </ul>
  </ErrorSubText>
  <ErrorWhiteButton>Join our slack</ErrorWhiteButton>
  </ErrorText>
  </Content>
  </ErrorContainer>
 */
